import BASEURLGESTTOR from '../api/gesttor'
import { paramsFiltrarCandidato, payloadAdicionarPergunta, payloadAtualizarPergunta } from '../../interfaces/BancoTalentos'

export function listarCandidatos(params: paramsFiltrarCandidato) {
    return BASEURLGESTTOR.get(`/listarCandidatos?nomeCompleto=${params.nomeCompleto}&situacao=${params.situacao}&cidade=${params.cidade}&estado=${params.estado}&campanha=${params.campanha}&interesseArea=${params.interesseArea}&interesseRegime=${params.interesseRegime}&pagina=${params.pagina}`)
}

export function adicionarPergunta(payload: payloadAdicionarPergunta) {
    return BASEURLGESTTOR.post(`/discPergunta`, payload)
}

export function atualizarPergunta(idPergunta: string, idAlternativa: string, payload: payloadAtualizarPergunta) {
    return BASEURLGESTTOR.patch(`/atualizarDiscPergunta/${idPergunta}/${idAlternativa}`, payload)
}

export function listarPerguntas() {
    return BASEURLGESTTOR.get(`/listaDiscPerguntas`)
}

export function enviarEmailCandidato(idProcessoSeletivo: string, idsCandidatos: string[]) {
    return BASEURLGESTTOR.post(`/bancoTalentos/email/${idProcessoSeletivo}`, { idsCandidatos })
}